import React, { useState } from "react";
import { createPortal } from "react-dom";
import api from "../services/api";
import "./componentStyles/AddInstitutionModal.css";

function AddInstitutionModal({ isOpen, onClose, onInstitutionAdded }) {
  const [institutionName, setInstitutionName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await api.post("/admin/upper-institutions", {
        ustKurum: institutionName.trim()
      });

      if (response.data.success) {
        setInstitutionName("");
        // pass created institution back so parent can select it
        onInstitutionAdded && onInstitutionAdded(response.data.data);
      }
    } catch (error) {
      setError(error.response?.data?.message || "Üst kurum eklenirken hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setInstitutionName("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  // Render at body root so it stacks above parent modals
  return createPortal(
    <div className="institution-modal-overlay" onClick={handleClose} style={{ zIndex: 3000 }}>
      <div className="institution-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>
          ×
        </button>
        
        <h3 className="modal-title">Yeni Üst Kurum Ekle</h3>
        
        <form onSubmit={handleSubmit} className="institution-form">
          <div className="form-group">
            <input
              type="text"
              value={institutionName}
              onChange={(e) => setInstitutionName(e.target.value)}
              placeholder="Üst kurum adını giriniz..."
              className="institution-input"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button 
              type="submit" 
              className="submit-btn3"
              disabled={loading || !institutionName.trim()}
            >
              {loading ? "Ekleniyor..." : "Ekle"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default AddInstitutionModal;
